import { FormikHelpers, FormikProps } from 'formik';
import { useMemo } from 'react';
import { FinalTermType } from '../app';
import { createSecurity, LEIType } from '../components';
import { ValidationRuleDto } from '../dto';
import { parseValidationResponseToDto } from '../helpers';
import { submitFinalTerms } from '../services';
import moment from 'moment';
import { LeiCategory } from '../../../constants';

export const useFinalTermsFormManagement = () => {
  // Fields to be validated with errors need to be initialized
  const initialValues = useMemo(() => {
    const query = new URLSearchParams(window.location.search);
    return {
      contact: {
        email: query.get('email') || '',
        name: query.get('contactPerson') || '',
      },
      baseProspectus: {
        dateOfApproval: query.get('approvalDate') ? (moment(query.get('approvalDate')).toDate() as any) : undefined,
        fileNumber: query.get('folderIdentifier') || '',
      },
      finalTermsDetails: {
        date: undefined as any,
        language: '',
        leiIssuers: [
          {
            category: LeiCategory.ISSUER,
            lei: '',
          },
        ],
        leiGuarantors: [] as LEIType[],
        euGreenBonds: false,
        bondMarketedAsEnvSys: false,
        susLinkedBonds: false,
      },
      securities: [createSecurity(1)],
      file: undefined as any,
      recaptcha: {
        token: '',
      },
      forceWarning: false,
    };
  }, []);

  const handleSubmit = async (
    token: string,
    fields: FinalTermType,
    helpers: FormikHelpers<FinalTermType>,
    onSuccessCallback: () => void,
    onValidationErrorCallback: (inconsistencies: ValidationRuleDto[]) => void,
    onErrorCallback: () => void
  ) => {
    helpers.setSubmitting(true);

    try {
      await submitFinalTerms(token, fields, fields.forceWarning);
      helpers.resetForm({
        values: {
          ...initialValues,
          contact: {
            ...fields.contact,
          },
          baseProspectus: {
            ...fields.baseProspectus,
          },
        },
      });

      onSuccessCallback();
    } catch (e: any) {
      await helpers.setFieldValue('forceWarning', false);
      if (e.response.status === 400 && e.response.data && e.response.data.validations) {
        onValidationErrorCallback(parseValidationResponseToDto(e.response));
      } else {
        onErrorCallback();
      }
    }

    helpers.setSubmitting(false);
  };

  const resetForm = ({ resetForm }: FormikProps<FinalTermType>) => {
    resetForm({
      values: {
        ...initialValues,
      },
    });
  };

  return {
    handleSubmit,
    resetForm,
    initialValues,
  };
};
